import { tarificatorModals } from './functions/tarificatorModals.js'
import './old.js'

tarificatorModals() // WCS-26402
